import React from "react";
import i18next from "i18next";
import {getMemberText, getPhoneNumberText, getTelegramChatText} from "../RulesComponents.model";

const DayTypes = {
  "i": ["rule.time.day.any", "any day"],
  "w": ["rule.time.day.weekday", "every weekday"],
  "h": ["rule.time.day.weekend", "every weekend"],
  "_default": ["unknown"]
};

const TextConverters = {
  "members": getMemberText,
  "phones": getPhoneNumberText,
  "chats": getTelegramChatText,
  "_default": (item) => item.toString()
};

export function getDayType(day) {
  return i18next.t(...(DayTypes[day] || DayTypes["_default"]));
}

export function getStringFromArray(array, name) {
  if (!array.length) {
    return `there are no ${name} yet`;
  }

  const convert = TextConverters[name] || TextConverters["_default"];

  return array.map((element, index) => (
      <React.Fragment key={`${name}_${index}`}>
        {convert(element).jsx}{index < (array.length - 1) && ", "}
      </React.Fragment>
    )
  );
}

export function compareElements(element, fullElement) {
  return typeof element === "object" ? element.id === fullElement.id : element === fullElement.id;
}

/**
 * Converts time to the word format.
 *
 * @param {"every" || "after"} firstWord - First word before time.
 * @param {string} time - Time in the format: d hh:mm:ss.
 * @returns {string|*} - Generated string.
 */
export function convertTimeToWordTime(firstWord, time) {
  if (typeof time !== "string") return time;

  function getS(str, type) {
    return i18next.t(`rule.time.${firstWord}.${type}`, {count: +str});
  }

  const splitedTime = time.split(" ");

  if (splitedTime[0] === "00:00:00") {
    return i18next.t("rule.time.immediately", "immediately");
  }

  const timeHasDays = splitedTime.length > 1;
  const hms = timeHasDays ? splitedTime[1].split(":") : splitedTime[0].split(":");

  const days = !timeHasDays ? "" : getS(splitedTime[0], "day");
  const hours = hms[0] === "00" ? "" : getS(hms[0], "hour");
  const minutes = hms[1] === "00" ? "" : getS(hms[1], "minute");
  const seconds = hms[2] === "00" ? "" : getS(hms[2], "second");
  const timeArray = [days, hours, minutes, seconds];
  const before = i18next.t(
    `rule.time.${firstWord}.${firstWord}`,
    {count: +([timeHasDays ? splitedTime[0] : 0, ...hms].find((element) => +element > 0))}
  );
  return (`${before} ${timeArray.join(" ").trim()}`);
}

export function restoreArray(compare, array, fullArray) {
  if (!fullArray) {
    return array || [];
  }

  return fullArray.filter((fullElement) => array.some((element) => compare(element, fullElement)));
}